import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterSSDIPageDatasetValidate = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("@honeycomb/ssdi/ssdi.css");
    import("@honeycomb/ssdi")
      .then((lib) => {
        resolve({
          default: () => <lib.ValidateDatasetPage />,
        });
      })
      .catch(reject);
  });
});

export const LazySSDIPageDatasetValidate = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterSSDIPageDatasetValidate />
    </Suspense>
  );
};
